import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import LeagueTable from '../common/LeagueTable';

export default function Standings({
  showBranding = false,
  competitionLabel = 'Premier League',
  table = [],
  groups = null,
}) {
  const hasGroups = Array.isArray(groups) && groups.length > 0;

  return (
    <div className="w-full" style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div
        className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
        style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
      >
        {competitionLabel}
      </div>

      {hasGroups ? (
        <div className="p-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {groups.map((group) => (
            <div
              key={group.id}
              className="rounded-lg border overflow-hidden"
              style={{ borderColor: 'var(--sw-border)', background: 'var(--sw-surface)' }}
            >
              <div
                className="px-3 py-1.5 text-xs font-bold uppercase tracking-wide"
                style={{
                  borderBottom: '1px solid var(--sw-border)',
                  color: 'var(--sw-muted)',
                }}
              >
                {group.label}
              </div>
              <div className="p-2">
                <LeagueTable
                  rows={group.table}
                  showTabs={false}
                  showLegend={false}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="p-3">
          <LeagueTable rows={table} />
        </div>
      )}

      {showBranding && <BrandingFooter />}
    </div>
  );
}
